import React, { useEffect, useState } from "react";
import SearchImg from "../../../assets/user/images/search1.svg";
import UserImg from "../../../assets/user/images/user.png";
import TrashImg from "../../../assets/user/images/trash.svg";
import Edit2 from "../../../assets/user/images/edit-2.svg";
import RightArrow from "../../../assets/user/images/right-arow.png";
import DatePicker from "react-datepicker";
import "../../../../node_modules/react-datepicker/dist/react-datepicker.css";
import deleteaccountImg from "../../../assets/user/images/delete-account.svg";
import FileImg from "../../../assets/provider/images/file.jpg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Loader from "../../../layouts/loader/Loader";
import { api } from "../../../utlis/staff/api.utlis";
import toast from "react-hot-toast";
import ApiService from "../../../core/services/ApiService";
import NoImage from "../../../assets/admin/images/no-image.jpg";
import NoData from "../../../assets/admin/images/no-data-found.svg";
import moment from "moment";
import uploadImage from "../../../assets/admin/images/uploadImage.svg";
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import { MultipleFile, SingleFile } from "../../../utlis/common.utlis";
import { Formik, Field, Form, FieldArray, ErrorMessage } from "formik";
import * as Yup from "yup";
import { routes } from "../../../utlis/user/routes.utlis";
import { encode, decode } from "base-64";

const Details = () => {
  const navigate = useNavigate();
  const localData = useLocation();
  const id = localData.state?.id;
  const [details, setDetails] = useState();
  const [loading, setLoading] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);
  const [selectedCommunityImages, setSelectedCommunityImages] = useState([]);
  const [selectedDeleteImages, setSelectedDeleteImages] = useState([]);
  const [unfollow, setUnfollow] = useState({
    status: false,
    id: null,
  });
  const [creation, setCreate] = useState({
    status: false,
    community_id: null,
  });
  const [desc, setDesc] = useState({
    status: false,
    description: null,
  });
  const [deleteCommunity, setDeleteCommunity] = useState({
    status: false,
    id: null,
  });
  const [editCommunity, setEditCommunity] = useState({
    status: false,
    id: null,
    title: null,
    description: null,
    cover_image: null,
  });

  const initialValues = {
    poll_title: editCommunity.title ?? "",
    description: editCommunity.description ?? "",
    post_image: "",
    poll: "no",
    options: [""],
  };

  const initialEditValues = {
    title: editCommunity.title ?? "",
    description: editCommunity.description ?? "",
    files: [],
  };

  const validationSchema = Yup.object().shape({
    poll_title: Yup.string().required("Title is required!"),
    description: Yup.string().required("Description is required!"),
    post_image: Yup.mixed()
      .test(
        "fileSize",
        "File size is too large",
        (value) => !value || (value && value.size <= SingleFile * 1024 * 1024)
      )
      .test("fileType", "Unsupported file type", (value) => {
        return value != "" && value != null && value != undefined
          ? ["image/jpeg", "image/png", "image/jpg"].includes(value.type)
          : true;
      }),
    poll: Yup.string().required("Please select Yes or No"),
  });

  const customValidate = (values) => {
    const errors = {};
    if (values.poll === "yes") {
      if (!values.options || values.options.length === 0) {
        errors.options = "At least one option is required";
      } else {
        const hasEmpty = values.options.some(
          (opt) => !opt || opt.trim() === ""
        );
        if (hasEmpty) {
          errors.options = "All poll options must be filled out";
        }
      }
    }
    return errors;
  };

  const validationEditSchema = Yup.object().shape({
    title: Yup.string().required("Title is required!"),
    description: Yup.string().required("Description is required!"),
    files: Yup.array()
      .max(3, "You can upload a maximum of 3 images")
      .test("fileType", "Unsupported file type", (files) =>
        files.every((file) =>
          file.file != "" && (file.file != null) & (file.file != undefined)
            ? ["image/jpeg", "image/png", "image/jpg"].includes(file.file.type)
            : true
        )
      )
      .test("fileSize", "File size is too large", (files) =>
        files.every((file) =>
          file.file != "" && (file.file != null) & (file.file != undefined)
            ? file.file.size <= MultipleFile * 1024 * 1024
            : true
        )
      ),
  });

  const followCommunity = async (comId) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(
      api.communityFollow + `${comId}`
    );
    if (response.data.status) {
      toast.success(response.data.message);
      getDetails(api.communityDetail + `${decode(id)}`);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const unFollowCommunity = async () => {
    setLoading(true);
    const response = await ApiService.deleteAPIWithAccessToken(
      api.communityUnFollow + `${unfollow.id}`
    );
    setUnfollow({
      status: false,
      id: null,
    });
    if (response.data.status) {
      toast.success(response.data.message);
      getDetails(api.communityDetail + `${decode(id)}`);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const likeUnlike = async (postId, ans) => {
    setLoading(true);
    const form = JSON.stringify({
      post_id: postId,
      object_type: "post",
      reaction: ans,
    });
    const response = await ApiService.postAPIWithAccessToken(
      api.postReaction,
      form
    );
    if (response.data.status) {
      toast.success(response.data.message);
      getDetails(api.communityDetail + `${decode(id)}`);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const addPost = async (formValue) => {
    setLoading(true);
    let form = new FormData();
    form.append("community_id", creation.community_id);
    form.append("poll_title", formValue.poll_title);
    form.append("description", formValue.description);
    if (formValue.post_image) {
      form.append("post_image", formValue.post_image);
    }
    if (formValue.options.length !== 0) {
      formValue.options
        .filter((opt) => opt && opt.trim() !== "")
        .forEach((opt) => form.append("poll_options[]", opt));
    }
    const response = await ApiService.postAPIWithAccessTokenMultiPart(
      api.postAdd,
      form
    );
    setCreate({ status: false, community_id: null });
    document.getElementById("add-post-form").reset();
    if (response.data.status) {
      toast.success(response.data.message);
      getDetails(api.communityDetail + `${decode(id)}`);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const updateCommunity = async (formValue) => {
    setLoading(true);
    let form = new FormData();
    form.append("title", formValue.title);
    form.append("description", formValue.description);
    if (formValue.files.length !== 0) {
      formValue.files.forEach((image) => {
        if (!image.isLive) form.append("cover_image", image.file);
      });
    }
    if (selectedDeleteImages.length !== 0) {
      selectedDeleteImages.forEach((ele) => {
        form.append("deleteImageId[]", ele);
      });
    }
    const response = await ApiService.putAPIWithAccessTokenMultiPart(
      api.communityUpdate + `${editCommunity.id}`,
      form
    );
    setEditCommunity({
      status: false,
      id: null,
      title: null,
      description: null,
      cover_image: null,
    });
    document.getElementById("update-community-form").reset();
    setSelectedImages([]);
    setSelectedDeleteImages([]);
    setSelectedCommunityImages([]);
    if (response.data.status) {
      toast.success(response.data.message);
      getDetails(api.communityDetail + `${decode(id)}`);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const deleteMyCommunity = async () => {
    setLoading(true);
    const response = await ApiService.deleteAPIWithAccessToken(
      api.communityDelete + `${deleteCommunity.id}`
    );
    setDeleteCommunity({ status: false, id: null });
    if (response.data.status) {
      toast.success(response.data.message);
      navigate(-1);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const getDetails = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    // console.log("community details => ", response.data);
    if (response.data.status && response.data.statusCode === 200) {
      setDetails(response.data.data.communityDetails);
      setSelectedCommunityImages(
        response.data.data.communityDetails?.cover_images
      );
    } else {
      setDetails();
    }
    setLoading(false);
  };

  const handleFileChange = (event, setFieldValue) => {
    const files = Array.from(event.target.files);
    if (files.length + selectedImages.length > 3) {
      alert("You can upload a maximum of 3 files.");
      return;
    }
    const imageUrls = files.map((file) => ({
      file,
      isLive: false,
      preview: URL.createObjectURL(file),
    }));
    setSelectedImages((prev) => [...prev, ...imageUrls]);
    setFieldValue("files", [...selectedImages, ...imageUrls]);
  };

  const removeImage = (index, setFieldValue, id = null) => {
    if (id != null) {
      const updatedCommunityImages = selectedCommunityImages.filter(
        (_, i) => i !== index
      );
      setSelectedCommunityImages(updatedCommunityImages);
      setSelectedDeleteImages((prev) => [...prev, id]);
    } else {
      const updatedImages = selectedImages.filter((_, i) => i !== index);
      setSelectedImages(updatedImages);
      setFieldValue("files", updatedImages);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getDetails(api.communityDetail + `${decode(id)}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      {loading ? <Loader /> : null}
      <div className="container">
        <div className="community--details-info">
          <div className="community-title-header">
            <h2 className="heading-title">Community Detail</h2>
            <div className="search-filter wd10">
              <div className="row g-2">
                <div className="col-md-12">
                  <Link
                    className="btn-gr wd100"
                    to=""
                    onClick={() => navigate(-1)}
                  >
                    Back
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <div className="community-details-media">
                <div
                  className="community-details-image-item"
                  style={{ height: "303px" }}
                >
                  <CarouselProvider
                    id="Main-Slider"
                    naturalSlideWidth={85}
                    naturalSlideHeight={49.5}
                    totalSlides={
                      details?.cover_images.length !== 0
                        ? details?.cover_images.length
                        : 1
                    }
                    isPlaying={true}
                  >
                    <Slider>
                      {details?.cover_images.length !== 0 ||
                      details?.cover_images !== null ||
                      details?.cover_images !== "" ||
                      details?.cover_images !== undefined ? (
                        details?.cover_images.map((ele, indx) => {
                          return (
                            <Slide key={indx} index={indx}>
                              <div className="item">
                                <div className="Main-Slider-media">
                                  <img src={ele.image} alt="Cover" />
                                </div>
                              </div>
                            </Slide>
                          );
                        })
                      ) : (
                        <img src={NoImage} alt="" />
                      )}
                    </Slider>
                  </CarouselProvider>
                </div>
              </div>
            </div>
            <div className="col-md-7">
              <div className="community-details-desc">
                <div className="community-details-head">
                  <div className="community-details-text">
                    <h4 className="text-capitalize">
                      {details?.title ?? "NA"}
                    </h4>
                  </div>
                </div>

                <div className="community-head-1">
                  <div className="community-head-media-1">
                    {details?.profile_image === null ||
                    details?.profile_image === "" ||
                    details?.profile_image === undefined ? (
                      <img src={NoImage} alt="" />
                    ) : (
                      <img src={details?.profile_image} alt="" />
                    )}
                  </div>
                  <div className="community-head-content-1">
                    <h4 className="text-capitalize">
                      {details?.fullname ?? "NA"}
                    </h4>
                  </div>
                  <div className="community-head-action-1">
                    {/* <button className="btn-gr">Share</button> */}
                  </div>
                </div>
                <p>
                  {details?.description ? (
                    details.description.length >= 75 ? (
                      <>
                        {details.description.slice(0, 75)}.....{" "}
                        <Link
                          style={{ color: "blue", textDecoration: "underline" }}
                          to=""
                          onClick={(e) => {
                            e.preventDefault();
                            setDesc({
                              status: true,
                              description: details?.description,
                            });
                          }}
                        >
                          read more
                        </Link>
                      </>
                    ) : (
                      details.description
                    )
                  ) : (
                    "NA"
                  )}
                </p>
                {details?.isCreated != "true" &&
                  (details?.is_following == "true" ? (
                    <button
                      className="btn-re mt-2"
                      onClick={(e) => {
                        e.preventDefault();
                        setUnfollow({
                          status: true,
                          id: details?.id,
                        });
                      }}
                    >
                      Unfollow
                    </button>
                  ) : (
                    <button
                      className="btn-bl mt-2"
                      onClick={(e) => {
                        e.preventDefault();
                        followCommunity(details?.id);
                      }}
                    >
                      Follow
                    </button>
                  ))}
                {details?.isCreated == "true" && (
                  <div className="community-details-action-1">
                    <button
                      className="btn-gr"
                      onClick={() => {
                        setEditCommunity({
                          status: true,
                          id: details?.id,
                          title: details?.title,
                          description: details?.description,
                          cover_image: details?.cover_images,
                        });
                      }}
                    >
                      <img src={Edit2} /> Edit
                    </button>
                    <button
                      className="btn-re mx-2"
                      onClick={() =>
                        setDeleteCommunity({ status: true, id: details?.id })
                      }
                    >
                      <img src={TrashImg} /> Delete
                    </button>
                  </div>
                )}
              </div>

              <div className="community-details-member-section">
                <div className="row align-items-center g-2">
                  <div className="col-md-12">
                    <div className="community-memberlist">
                      <div className="community-memberlist-text">
                        <h2>Followers</h2>
                        <p>{details?.member_count ?? "NA"}</p>
                      </div>
                      <div className="community-memberlist-image">
                        {details?.last_following_member_images?.length !== 0 ? (
                          details?.last_following_member_images?.map(
                            (element, index) => {
                              return (
                                <div
                                  key={index}
                                  className={
                                    "folllow-user-image image" + `${index + 1}`
                                  }
                                >
                                  {element === null ||
                                  element === "" ||
                                  element === undefined ? (
                                    <img src={NoImage} alt="No profile" />
                                  ) : (
                                    <img
                                      src={element}
                                      alt={`Member ${index + 1}`}
                                    />
                                  )}
                                </div>
                              );
                            }
                          )
                        ) : (
                          <div className="folllow-user-image image1">
                            <img src={NoImage} alt="No profile" />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-12 mt-3">
          <div className="community-comment-section">
            <div className="community-comment-list">
              <div className="community-comment-box-head">
                <h1>Community Post</h1>
                <div className="community-comment-head-action">
                  {details?.isCreated != "true" ? (
                    details?.is_following == "true" ? (
                      <Link
                        className="addcomment-btn"
                        to=""
                        onClick={(e) => {
                          e.preventDefault();
                          setCreate({ status: true, community_id: decode(id) });
                        }}
                      >
                        <i className="fa fa-plus"></i> Add Post
                      </Link>
                    ) : (
                      <Link
                        className="addcomment-btn"
                        to=""
                        onClick={(e) => {
                          e.preventDefault();
                          toast.error("Please follow the community to post");
                        }}
                      >
                        <i className="fa fa-plus"></i> Add Post
                      </Link>
                    )
                  ) : (
                    <Link
                      className="addcomment-btn"
                      to=""
                      onClick={(e) => {
                        e.preventDefault();
                        setCreate({ status: true, community_id: decode(id) });
                      }}
                    >
                      <i className="fa fa-plus"></i> Add Post
                    </Link>
                  )}
                </div>
              </div>

              <div className="row">
                {details?.communityFeed?.length !== 0 &&
                details?.communityFeed !== "" &&
                details?.communityFeed !== null &&
                details?.communityFeed !== undefined ? (
                  details?.communityFeed?.map((ele, indx) => {
                    return (
                      <div key={indx} className="col-md-4">
                        <div className="community-card">
                          <div className="community-head">
                            <div className="community-head-media">
                              {ele.profile_image === null ||
                              ele.profile_image === "" ||
                              ele.profile_image === undefined ? (
                                <img src={NoImage} alt="" />
                              ) : (
                                <img src={ele.profile_image} alt="" />
                              )}
                            </div>
                            <div className="community-head-content text-capitalize">
                              <h4>{ele.fullname ?? "NA"}</h4>
                            </div>
                            <div className="community-head-action">
                              {ele.post_type !== "normal_post" && (
                                <div className="exp-text mx-2 mb-1">
                                  Shared Post
                                </div>
                              )}
                              <Link
                                className="view-font-btn"
                                style={{ width: "31px", height: "31px" }}
                                to=""
                                onClick={(e) => {
                                  e.preventDefault();
                                  navigate(routes.communityPostInfo, {
                                    state: {
                                      id: encode(ele.post_id),
                                      isCreated: details?.isCreated ?? "false",
                                    },
                                  });
                                }}
                              >
                                <img width={19} src={RightArrow} />
                              </Link>
                            </div>
                          </div>
                          <div className="community-image">
                            {ele.post_image === null ||
                            ele.post_image === "" ||
                            ele.post_image === undefined ? (
                              <img src={NoImage} alt="" />
                            ) : (
                              <img src={ele.post_image} alt="" />
                            )}
                          </div>
                          <div className="community-content">
                            <h3 className="text-capitalize">
                              {ele.poll_title ?? "NA"}
                            </h3>
                            <p>{ele.description ?? "NA"}</p>
                            <div className="d-flex justify-content-between mb-2">
                              <div
                                className="like-button-comm"
                                onClick={(e) => {
                                  e.preventDefault();
                                  likeUnlike(
                                    ele.post_id,
                                    ele.isLiked == "true" ? "unlike" : "like"
                                  );
                                }}
                              >
                                <input
                                  className="on"
                                  id="heart"
                                  type="checkbox"
                                  checked={ele.isLiked == "true" ? true : false}
                                />
                                <label className="like-comm" for="heart">
                                  <svg
                                    className="like-icon-comm"
                                    fill-rule="nonzero"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path d="m11.645 20.91-.007-.003-.022-.012a15.247 15.247 0 0 1-.383-.218 25.18 25.18 0 0 1-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0 1 12 5.052 5.5 5.5 0 0 1 16.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 0 1-4.244 3.17 15.247 15.247 0 0 1-.383.219l-.022.012-.007.004-.003.001a.752.752 0 0 1-.704 0l-.003-.001Z"></path>
                                  </svg>
                                  <span className="like-text-comm">Like</span>
                                </label>
                                <span className="like-count-comm">
                                  {ele.like_count ?? 0}
                                </span>
                              </div>
                            </div>

                            {/* {ele.poll_options?.length !== 0
                              ? ele.poll_options?.map((element, index) => {
                                  return (
                                    <div
                                      key={index}
                                      className="poll-option selected"
                                    >
                                      <div className="poll-header">
                                        <label>
                                          <input
                                            type="radio"
                                            name="poll"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              pollAnswer(
                                                ele.poll_id,
                                                element.option_id
                                              );
                                            }}
                                            checked={
                                              element.isAnswer == "true"
                                                ? true
                                                : false
                                            }
                                          />
                                          {element.option_value}
                                        </label>
                                        <span>{element.vote_percentage}</span>
                                      </div>
                                      <div className="poll-bar">
                                        <div
                                          className="poll-fill"
                                          style={{
                                            width: `${element.vote_percentage}`,
                                          }}
                                        ></div>
                                      </div>
                                    </div>
                                  );
                                })
                              : null} */}
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "5% 0",
                    }}
                  >
                    <img width={300} src={NoData} alt="" />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={unfollow.status}
        onHide={() => {
          setUnfollow({
            status: false,
            id: null,
          });
        }}
        className="cc-modal-form"
      >
        <div className="modal-content">
          <ModalBody className="">
            <div className="add-items d-flex row">
              <div className="deleteaccount-text mb-4">
                <h5 className="text-center pb-0">Unfollow Community</h5>
                <p className="text-center">
                  Are you sure you want to unfollow this community?
                </p>
              </div>
              <div className="form-group text-center mb-2">
                <button
                  type="button"
                  onClick={() =>
                    setUnfollow({
                      status: false,
                      id: null,
                    })
                  }
                  className="btn-wh-re me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn-re"
                  data-bs-dismiss="modal"
                  onClick={() => unFollowCommunity()}
                >
                  Yes! Unfollow
                </button>
              </div>
            </div>
          </ModalBody>
        </div>
      </Modal>

      <Modal
        show={creation.status}
        onHide={() => {
          setCreate({
            status: false,
            community_id: null,
          });
        }}
        className="modal-xl"
      >
        <div className="modal-content">
          <ModalHeader>
            <h5 className="mb-0">Add Post</h5>
          </ModalHeader>
          <ModalBody className="">
            <div className="add-items d-flex row">
              <Formik
                initialValues={initialValues}
                validateOnChange={true}
                validationSchema={validationSchema}
                validate={customValidate}
                onSubmit={addPost}
                enableReinitialize
              >
                {({ values, setFieldValue }) => (
                  <Form className="findcare-form" id="add-post-form">
                    <div className="form-group">
                      <h4>Title</h4>
                      <Field
                        type="text"
                        className="form-control todo-list-input"
                        name="poll_title"
                        placeholder="Enter Title"
                      />
                      <ErrorMessage
                        name="poll_title"
                        component="div"
                        className="alert alert-danger"
                      />
                    </div>
                    <div className="form-group">
                      <h4>
                        Upload Image{" "}
                        <span
                          className="text-danger"
                          style={{ fontSize: "0.7rem" }}
                        >
                          (In JPG, JPEG & PNG)
                        </span>
                      </h4>
                      <div className="upload-signature">
                        <Field name="post_image">
                          {({ field, form }) => (
                            <>
                              <input
                                type="file"
                                id="files"
                                accept="image/jpg, image/jpeg, image/png"
                                className="form-control addsignature todo-list-input"
                                style={{ position: "absolute" }}
                                onChange={(event) =>
                                  setFieldValue(
                                    "post_image",
                                    event.currentTarget.files[0]
                                  )
                                }
                              />
                              <label for="files">
                                <div className="signature-text">
                                  <span>
                                    <img src={uploadImage} alt="" />
                                    <small className="prev-filename">
                                      {values?.post_image?.name
                                        ? values?.post_image?.name
                                        : "Click here to Upload Image"}
                                    </small>
                                  </span>
                                </div>
                              </label>
                            </>
                          )}
                        </Field>
                        <ErrorMessage
                          name="post_image"
                          component="div"
                          className="alert alert-danger"
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <h4>Description</h4>
                      <Field
                        type="text"
                        as="textarea"
                        className="form-control"
                        name="description"
                        placeholder="Enter Description"
                        style={{ height: "150px" }}
                      />
                      <ErrorMessage
                        name="description"
                        component="div"
                        className="alert alert-danger"
                      />
                    </div>
                    <div className="form-group">
                      <h4>Create Poll</h4>
                      <div className="choosemiles-list">
                        <ul>
                          <li>
                            <div className="ceradio">
                              <Field
                                type="radio"
                                name="poll"
                                id="Hour"
                                value="yes"
                              />
                              <label for="Hour">
                                <span className="checkbox-text"> Yes</span>
                              </label>
                            </div>
                          </li>
                          <li>
                            <div className="ceradio">
                              <Field
                                type="radio"
                                name="poll"
                                id="Daily"
                                value="no"
                              />
                              <label for="Daily">
                                <span className="checkbox-text"> No</span>
                              </label>
                            </div>
                          </li>
                        </ul>
                        <ErrorMessage
                          name="pay_range_type"
                          component="div"
                          className="alert alert-danger"
                        />
                      </div>
                    </div>
                    {values.poll == "yes" ? (
                      <div className="form-group">
                        <FieldArray name="options">
                          {({ push, remove }) => (
                            <div>
                              {values.options.map((option, index) => (
                                <div
                                  key={index}
                                  style={{
                                    display: "flex",
                                    marginBottom: "10px",
                                  }}
                                >
                                  <Field
                                    name={`options.${index}`}
                                    placeholder={`Enter Poll Options`}
                                    className="form-control me-3"
                                  />
                                  <button
                                    type="button"
                                    className="btn-re"
                                    onClick={() => remove(index)}
                                    disabled={values.options.length === 0}
                                  >
                                    <img src={TrashImg} />
                                  </button>
                                </div>
                              ))}
                              <ErrorMessage
                                name="options"
                                component="div"
                                className="alert alert-danger"
                              />
                              <button
                                type="button"
                                className="btn-gr"
                                onClick={() => push("")}
                              >
                                <i className="fa fa-plus"></i>
                              </button>
                            </div>
                          )}
                        </FieldArray>
                      </div>
                    ) : null}
                    <div className="form-group text-end">
                      <button
                        type="button"
                        onClick={() => {
                          setCreate({
                            status: false,
                            community_id: null,
                          });
                        }}
                        className="btn btn-re me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-gr me-2"
                        data-bs-dismiss="modal"
                      >
                        Add
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </ModalBody>
        </div>
      </Modal>

      <Modal
        show={deleteCommunity.status}
        onHide={() => {
          setDeleteCommunity({ status: false, id: null });
        }}
        className="cc-modal-form"
      >
        <div className="modal-content">
          <ModalBody className="">
            <div className="add-items d-flex row">
              <div className="deleteaccount-Img">
                <img src={deleteaccountImg} />
              </div>
              <div className="deleteaccount-text mb-4">
                <h5 className="text-center pb-0">Delete Community</h5>
                <p className="text-center">
                  Deleting this community cannot be undone. Are you sure you
                  want to proceed ?
                </p>
              </div>
              <div className="form-group text-center mb-2">
                <button
                  type="button"
                  onClick={() =>
                    setDeleteCommunity({ status: false, id: null })
                  }
                  className="btn-wh-re me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn-re"
                  data-bs-dismiss="modal"
                  onClick={() => deleteMyCommunity()}
                >
                  Yes! Delete
                </button>
              </div>
            </div>
          </ModalBody>
        </div>
      </Modal>

      <Modal
        show={editCommunity.status}
        onHide={() => {
          setEditCommunity({
            status: false,
            id: null,
            title: null,
            description: null,
            cover_image: null,
          });
        }}
        className="modal-xl"
      >
        <div className="modal-content">
          <ModalHeader>
            <h5 className="mb-0">Edit Community</h5>
          </ModalHeader>
          <ModalBody className="">
            <div className="add-items d-flex row">
              <Formik
                initialValues={initialEditValues}
                validateOnChange={true}
                validationSchema={validationEditSchema}
                onSubmit={updateCommunity}
                enableReinitialize
              >
                {({ values, setFieldValue }) => (
                  <Form className="findcare-form" id="update-community-form">
                    <div className="form-group">
                      <h4>Title</h4>
                      <Field
                        type="text"
                        className="form-control todo-list-input"
                        name="title"
                        placeholder="Enter Title"
                      />
                      <ErrorMessage
                        name="title"
                        component="div"
                        className="alert alert-danger"
                      />
                    </div>
                    <div className="form-group">
                      <h4>
                        Upload Image(s){" "}
                        <span
                          className="text-danger"
                          style={{ fontSize: "0.7rem" }}
                        >
                          (In JPG, JPEG, & PNG)
                        </span>
                      </h4>
                      <div className="upload-signature">
                        <Field name="files">
                          {({ field, form }) => (
                            <div>
                              <input
                                type="file"
                                multiple
                                accept="image/jpg, image/jpeg, image/png"
                                className="form-control"
                                onChange={(event) =>
                                  handleFileChange(event, setFieldValue)
                                }
                              />
                            </div>
                          )}
                        </Field>
                        <ErrorMessage
                          name="files"
                          component="div"
                          className="alert alert-danger"
                        />
                      </div>
                    </div>
                    <div className="row mb-3 mx-1">
                      {selectedCommunityImages?.map((img, index) => (
                        <div
                          key={index}
                          className="col-md-2 d-flex flex-column align-items-center"
                        >
                          <div className="mb-2">
                            <Link to={img.image} target="_blank">
                              <img
                                style={{
                                  borderRadius: "8px",
                                  objectFit: "cover",
                                  objectPosition: "center",
                                  width: "160px",
                                  height: "100px",
                                }}
                                src={img.image}
                                alt=""
                              />
                            </Link>
                          </div>
                          <div>
                            <button
                              type="button"
                              className="delete-btn"
                              onClick={() => {
                                removeImage(
                                  index,
                                  setFieldValue,
                                  img.id ?? null
                                );
                              }}
                            >
                              <img src={TrashImg} />
                            </button>
                          </div>
                        </div>
                      ))}
                      {selectedImages.map((img, index) => (
                        <div
                          key={index}
                          className="col-md-2 d-flex flex-column align-items-center"
                        >
                          <div className="mb-2">
                            <Link to={img.preview} target="_blank">
                              <img
                                style={{
                                  borderRadius: "8px",
                                  objectFit: "cover",
                                  objectPosition: "center",
                                  width: "160px",
                                  height: "100px",
                                }}
                                src={img.preview}
                                alt=""
                              />
                            </Link>
                          </div>
                          <div>
                            <button
                              type="button"
                              className="delete-btn"
                              onClick={() => {
                                removeImage(index, setFieldValue);
                              }}
                            >
                              <img src={TrashImg} />
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="form-group">
                      <h4>Description</h4>
                      <Field
                        type="text"
                        as="textarea"
                        className="form-control"
                        name="description"
                        placeholder="Enter Description"
                        style={{ height: "150px" }}
                      />
                      <ErrorMessage
                        name="description"
                        component="div"
                        className="alert alert-danger"
                      />
                    </div>
                    <div className="form-group text-end">
                      <button
                        type="button"
                        onClick={() => {
                          setEditCommunity({
                            status: false,
                            id: null,
                            title: null,
                            description: null,
                            cover_image: null,
                          });
                        }}
                        className="btn btn-re me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-gr me-2"
                        data-bs-dismiss="modal"
                      >
                        Update
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </ModalBody>
        </div>
      </Modal>

      <Modal
        show={desc.status}
        onHide={() => {
          setDesc({ status: false, description: null });
        }}
        className="cc-modal-form"
      >
        <div className="modal-content">
          <ModalBody className="">
            <div className="add-items d-flex row">
              <div className="deleteaccount-text mb-0">
                <p className="p-3" style={{ color: "black" }}>
                  {desc.description ?? "NA"}
                </p>
              </div>
              <div className="form-group text-end mb-2">
                <button
                  type="button"
                  onClick={() => setDesc({ status: false, description: null })}
                  className="btn-wh-re me-2"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </ModalBody>
        </div>
      </Modal>
    </>
  );
};

export default Details;
